import { useAdminPatients } from "@/portals/admin/context/AdminPatientsContext";

export function AdminDashboardPage() {
  const { patients, total } = useAdminPatients();

  // Verified/disabled counts only reflect the current page — the backend
  // doesn't expose an aggregate count across the full patient list.
  const verifiedOnPage = patients.filter(p => p.is_verified).length;
  const disabledOnPage = patients.filter(p => p.is_disabled).length;

  const stats = [
    { label: "Total Patients",          value: total          },
    { label: "Verified (this page)",    value: verifiedOnPage },
    { label: "Disabled (this page)",    value: disabledOnPage },
  ];

  return (
    <div className="min-h-full bg-[#F7F7F7] px-4 py-4 lg:px-6 lg:py-5">

      {/* Stats cards — same minimal dashboard style */}
      <div className="mb-6 grid gap-5 sm:grid-cols-3">
        {stats.map(({ label, value }) => (
          <div
            key={label}
            className="flex cursor-default flex-col justify-between min-h-[110px] rounded-3xl border border-[#E5E7EB] bg-white px-6 py-5 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-lg"
          >
            <p className="text-sm font-normal text-[#9CA3AF]">{label}</p>
            <div className="flex justify-end">
              <p className="text-3xl font-bold text-[#111827]">{value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Quick actions info */}
      <div className="rounded-3xl border border-[#E5E7EB] bg-white p-5 shadow-sm">
        <h2 className="text-base font-extrabold tracking-tight text-[#0A2947]">Quick Actions</h2>
        <p className="mt-1 text-xs text-[#4B5563]">
          Use Patients to search and review accounts registered through the patient portal.
        </p>
      </div>
    </div>
  );
}